export default "__VITE_ASSET__4223e023__"